import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TestAccountListPageUI from './TestAccountListPageUI.js'

class TestAccountListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountList: null,
      deleteSubmitted: false,
      recreateSubmitted: false,
      selectedAccountId: null,
      createLoanMode: false,
      selectedAccountId: null,
      result: null
    }
  }

  render() {
    return (
      <TestAccountListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        onRefreshClick={this.onRefreshClick}
        onDeleteClick={this.onDeleteClick}
        onRecreateClick={this.onRecreateClick}
        deleteSubmitted={this.state.deleteSubmitted}
        recreateSubmitted={this.state.recreateSubmitted}
        selectedAccountId={this.state.selectedAccountId}
        onHideResult={() => {this.setState({ result: null })}}
        result={this.state.result}
        createLoanMode={this.state.createLoanMode}
        onCreateLoanClick={this.onCreateLoanClick}
        onCancelCreateLoan={() => this.setState({createLoanMode: false})}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTestAccounts(context)
  }

  getTestAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/testAccounts`,
      cacheKey: CacheKeys.TestAccounts(),
      callback: this.getTestAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTestAccountsCallback = (response) => {
    this.setState({errorList: response.errorList, accountList : response.accountList})
  }

  onDeleteClick = (event) => {
    let accountId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      deleteSubmitted: true,
      selectedAccountId: accountId
    })

    RestApiUtils.delete(this.props.context,
      `/api/testAccounts/${accountId}/testData`,
      this.onDeleteCallback, {
      }
    )
  }

  onDeleteCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteSubmitted: false,
      result: response.result
    }, this.onRefreshClick())
  }

  onRecreateClick = (event) => {
    let accountId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      recreateSubmitted: true,
      selectedAccountId: accountId
    })

    RestApiUtils.put(this.props.context,
      `/api/testAccounts/${accountId}/testData`,
      this.onRecreateCallback, {
      }
    )
  }

  onRecreateCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      recreateSubmitted: false,
      result: response.result
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      this.onRefreshClick()
    }
  }

  onCreateLoanClick = (event) => {
    let accountId = event.target.getAttribute('data-row-id')
    this.setState({selectedAccountId: accountId, createLoanMode: true})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.TestAccounts())
    this.setState({accountList: null, errorList: null})
    this.getTestAccounts(this.props.context)
  }
}

export default TestAccountListPageSF
